module.exports = __webpack_public_path__ + "img/headwear.758dd219.svg";